<template>
    <div class="counterparty" v-if="final_files.length > 0">
        <legend>
            Поточна версія договору
        </legend>
        
        <b-table striped  head-variant="dark" :thead-class="head_class"  striped class="table-responsive-xl resolution_table" :items="final_files" :fields="fields">
            <template  v-slot:head(link)="data">
                 <span  class="text-info text-center">
                     <i class="fa fa-floppy-o" aria-hidden="true"></i>
                 </span>
            </template>
            
            
            <template  v-slot:cell(link)="data" >
                    <span class="get_file cursor-pointer text-center fs-xl" @click="get_file(data.item)">
                     <i class="fal  fa-save save_me"></i>
                </span>
                
            </template>
        </b-table>
    </div>
</template>


<script>
export default {
    name: "mem_inside_dogovor",
    props : {
        "addon_data" : {
            type : Object
        },
        
        'mem' : {
            type : Object
        },
    },
    
    data() {
        return  {
            list_items : [],
            
            fields: [
                
                {
                    key: 'id',
                    label: 'ID',
                    sortable: true
                },
                {
                    key: 'name',
                    label: 'Назва',
                    sortable: true
                },
                {
                    key: 'user_small',
                    label: 'ПIБ',
                    sortable: true
                },
                
                {
                    key: 'added_human',
                    label: 'Дата',
                    sortable: true
                },
                
                {
                    key: 'link',
                    label: 'dd',
                    sortable: false
                },
                
            ],
        }
    },
    
    methods : {
        
        get_file(item) {
            console.log(item);
            
            api.get('/files/' + item.id, { responseType: 'blob' }) // responseType важен!
                .then(response => {
                    if (response.status === 200) {
                        const fileURL = window.URL.createObjectURL(new Blob([response.data]));
                        const fileLink = document.createElement('a');
                        fileLink.href = fileURL;
                        fileLink.setAttribute('download', item.name); // Имя файла
                        document.body.appendChild(fileLink);
                        fileLink.click();
                        document.body.removeChild(fileLink);
                    } else {
                        EventBus.$emit('show_toast', { err: 'File not found', type: "danger", title: 'Error' });
                    }
                })
                .catch(err => {
                    EventBus.$emit('show_toast', { err: err.message, type: "danger", title: err.name });
                })
                .finally(() => {
                
                });
        },
    },
    
    computed : {
        files() {
            if(this.addon_data.hasOwnProperty('last_work_file')) {
                return this.addon_data.last_work_file;
            }
            return {
                'final_files' : [],
                'init_files' : [],
            };
        },
        
        final_files() {
            return this.files.final_files;
        },
        
        head_class() {
            // if(!this.show_head) {
            // return 'hidden_header';
            // }
        },
    },
}
</script>


<style scoped>

</style>